import { lightTheme } from '../../themes';
export default {
    pill: {
        fontFamily: 'AvenirNext-DemiBold',
        display: 'inline-block',
        borderRadius: '9px',
        margin: '2px 10px',
        minWidth: '18px',
        padding: '0px 2px',
        height: '18px',
        color: '#4a4a4a',
        fontSize: '10px',
        lineHeight: '18px',
        textAlign: 'center',
        cursor: 'pointer'
    },
    selected: {
        color: 'white',
        backgroundColor: lightTheme.palette.primary.main
    }
}